// Central place for all brand copy so components stay self-contained
// and content can be updated without touching JSX.
import leaf from "../assets/leaf-svgrepo-com.svg";
import earth from "../assets/earth-north-svgrepo-com.svg";
import heart from "../assets/heart-alt-svgrepo-com.svg";
import Kerala from "../assets/kerala.png";
import Germany from "../assets/germany.png";
import EU from "../assets/European Union.png";
import leafbrand from "../assets/leaf.png";
import hands from "../assets/care.png";
import gift from "../assets/delivery.png";

export const brand = {
  name: "Terra Palm",
  tagline: "Natural Creations",
  strapline: "From Malabar Forest to Your Forever",
  since: "A Sustainable Livelihood Initiative",
  pillars: ["Natural", "Sustainable", "Handcrafted", "Timeless"],
};

export const heroContent = {
  eyebrow: "Terra Bloom Studio",
  title: "Nature Preserved.",
  titleAccent: "Beauty Forever.",
  intro:
    "We have been experimenting and perfecting crafts made from corn husk, paddy straw, pistachio shells, cane, coconut shells, sola wood, banana fibre & areca leaf, marjoram, silk cocoon, dried millet, pampas grass, and more — materials that are otherwise burnt or discarded by Kerala farmers.",
  ctaLabel: "Explore Our HandiCrafts",
  stats: [
    { value: "12+", label: "Natural Materials" },
    { value: "100%", label: "Eco-Friendly" },
    { value: "2", label: "Founders, One Vision" },
  ],
};

// Placeholder product photography for the hero showcase — swap for
// real photography of your dry flower & eco craft pieces.
export const heroShowcaseImages = [
  "https://images.unsplash.com/photo-1508502726440-477c94b40026?w=400&q=80",
  "https://images.unsplash.com/photo-1487530811176-3780de880c2d?w=400&q=80",
  "https://images.unsplash.com/photo-1533616688419-b7a585564566?w=400&q=80",
  "https://images.unsplash.com/photo-1490750967868-88aa4486c946?w=400&q=80",
  "https://images.unsplash.com/photo-1520763185298-1b434c919102?w=400&q=80",
  "https://images.unsplash.com/photo-1509721434272-b79147e0e708?w=400&q=80",
  "https://images.unsplash.com/photo-1526047932273-341f2a7631f9?w=400&q=80",
  "https://images.unsplash.com/photo-1463320726281-696a485928c7?w=400&q=80",
  "https://images.unsplash.com/photo-1502741224143-90386d7f8c82?w=400&q=80",
  "https://images.unsplash.com/photo-1471421521033-be0009386301?w=400&q=80",
  "https://images.unsplash.com/photo-1490750967868-88aa4486c946?w=400&q=80",
  "https://images.unsplash.com/photo-1520763185298-1b434c919102?w=400&q=80",
];

export const whoWeAre = {
  eyebrow: "Brand Story",
  heading:
    "Terra Bloom Studio is born from a passion for nature and creativity",
  paragraphs: [
    "Terra Bloom Studio is born from a passion for nature and creativity. We craft exquisite dry flower arrangements and eco-friendly creations that preserve nature's beauty and bring everlasting joy to your special moments.",
    "We transform Kerala's natural waste — flowers, palm leaves, and vines — into timeless decor. Every product supports local farmers and empowers women artisans.",
    "To create a sustainable ecosystem of dry flower and eco craft enterprises in Kerala that empowers communities, preserves nature, and promotes a green economy.",
  ],
  certifications: [
    "Women Empowerment",
    "Plastic-Free Kerala",
    "Waste to Wealth for Farmers",
  ],
  whyItMatters: [
    { title: "Supports Local Farmers", svg: leaf },
    { title: "Protect our Environment", svg: earth },
    { title: "Promotes Healthy Living", svg: heart },
  ],
  statCallout: { value: "2", label: "Founders, One Shared Vision" },
  gallery: [
    "https://images.unsplash.com/photo-1465310477141-6fb93167a273?w=900&q=80",
    "https://images.unsplash.com/photo-1487530811176-3780de880c2d?w=900&q=80",
    "https://images.unsplash.com/photo-1508502726440-477c94b40026?w=900&q=80",
    "https://images.unsplash.com/photo-1490750967868-88aa4486c946?w=900&q=80",
  ],
};

// "What We Make" — product category groups shown on the Home page.
export const productCategories = [
  {
    id: "bridal-celebration",
    eyebrow: "What We Make",
    label: "Product Categories",
    heading: "Bridal & Celebration Crafts",
    description:
      "Handmade from sola wood, areca leaf, and natural fibre, every bouquet and hanging is built for weddings, festivals, and gifting — with custom colour schemes and bulk packaging available.",
    seeAllLabel: "See All Bridal & Celebration Products",
    groups: [
      {
        title: "Bridal & Wedding",
        styleCount: 4,
        image: "/Assets/handicrafts/image1.jpeg",
      },
      {
        title: "Areca Leaf Crafts",
        styleCount: 2,
        image: "/Assets/handicrafts/image2.jpeg",
      },
      {
        title: "Wall Hangings",
        styleCount: 3,
        image: "/Assets/handicrafts/image3.jpeg",
      },
    ],
  },
  // {
  //   id: "home-grain",
  //   eyebrow: "What We Make",
  //   label: "Product Categories",
  //   heading: "Home & Grain Crafts",
  //   description:
  //     "Coconut shells, pistachio shells, and paddy straw reshaped into everyday decor — table arrangements, pots, and hangings finished by hand in Kerala.",
  //   seeAllLabel: "See All Home & Grain Products",
  //   groups: [
  //     {
  //       title: "Home & Table Decor",
  //       styleCount: 2,
  //       image:
  //         "https://images.unsplash.com/photo-1471421521033-be0009386301?w=700&q=80",
  //     },
  //     {
  //       title: "Shell & Nut Crafts",
  //       styleCount: 2,
  //       image:
  //         "https://images.unsplash.com/photo-1509721434272-b79147e0e708?w=700&q=80",
  //     },
  //     {
  //       title: "Paddy & Grain Crafts",
  //       styleCount: 2,
  //       image:
  //         "https://images.unsplash.com/photo-1533616688419-b7a585564566?w=700&q=80",
  //     },
  //   ],
  // },
];

// "Wall of Fame" — a showcase of Terra Bloom Studio's own craft,
// workshop, and artisan moments.
export const wallOfFame = {
  eyebrow: "From Our Workshop To Your Home",
  heading: "Wall of Crafts",
  sub: "Moments from our Kerala workshop, our artisans, and the crafts that got us here.",
  images: [
    "/Assets/walloffame/image1.jpeg",
    "/Assets/walloffame/image2.jpeg",
    "/Assets/walloffame/image3.jpeg",
    "/Assets/walloffame/image4.jpeg",
    "/Assets/walloffame/image5.jpeg",
    "/Assets/walloffame/image6.jpeg",
  ],
};

// ---------------------------------------------------------------------
// Home page "Gallery" — filterable showcase of finished craft pieces.
// Pulls from the same handicrafts photo set used across the site.
// ---------------------------------------------------------------------
export const galleryContent = {
  eyebrow: "Our Gallery",
  heading: "A Closer Look At Our Crafts",
  sub: "Every piece is hand-finished in our Kerala workshop — browse a few favourites, filtered by category.",
  seeAllLabel: "See Gallery",
};

export const galleryFilters = [
  "All",
  "Bridal & Wedding",
  "Areca Leaf Crafts",
  "Wall Hangings",
  "Home & Table Decor",
  "Shell & Nut Crafts",
  "Paddy & Grain Crafts",
];

export const galleryItems = [
  {
    id: "gal-01",
    title: "Ivory Rose Bouquet",
    category: "Bridal & Wedding",
    image: "/Assets/handicrafts/image1.jpeg",
  },
  {
    id: "gal-02",
    title: "Wedding Bouquet",
    category: "Bridal & Wedding",
    image: "/Assets/handicrafts/image2.jpeg",
  },
  {
    id: "gal-03",
    title: "Areca Leaf Rose Frame",
    category: "Areca Leaf Crafts",
    image: "/Assets/handicrafts/image8.jpeg",
  },
  {
    id: "gal-04",
    title: "Areca Leaf Wall Piece",
    category: "Areca Leaf Crafts",
    image: "/Assets/handicrafts/image11.jpeg",
  },
  {
    id: "gal-05",
    title: "Woven Wall Hanging",
    category: "Wall Hangings",
    image: "/Assets/handicrafts/image3.jpeg",
  },
  {
    id: "gal-06",
    title: "Dried Botanical Hanging",
    category: "Wall Hangings",
    image: "/Assets/handicrafts/image14.jpeg",
  },
  {
    id: "gal-07",
    title: "Table Top Arrangement",
    category: "Home & Table Decor",
    image: "/Assets/handicrafts/image6.jpeg",
  },
  {
    id: "gal-08",
    title: "Centrepiece Bowl",
    category: "Home & Table Decor",
    image: "/Assets/handicrafts/image18.jpeg",
  },
  {
    id: "gal-09",
    title: "Pistachio Petal Blossom",
    category: "Shell & Nut Crafts",
    image: "/Assets/handicrafts/image10.jpeg",
  },
  {
    id: "gal-10",
    title: "Coconut Shell Vase",
    category: "Shell & Nut Crafts",
    image: "/Assets/handicrafts/image21.jpeg",
  },
  {
    id: "gal-11",
    title: "Paddy Coated Pot",
    category: "Paddy & Grain Crafts",
    image: "/Assets/handicrafts/image12.jpeg",
  },
  {
    id: "gal-12",
    title: "Millet & Grain Basket",
    category: "Paddy & Grain Crafts",
    image: "/Assets/handicrafts/image26.jpeg",
  },
];

// Curated preview set for compact spots (e.g. the Home page mobile
// carousel) where showing all 34 products would be too much.
export const featuredProducts = [
  {
    id: "TBS-SPD-001",
    name: "Ivory Rose Bouquet",
    code: "TBS-SPD-001",
    image: "/Assets/handicrafts/image1.jpeg",
    category: "Sola & Pith Crafts",
  },
  {
    id: "TBS-WB-002",
    name: "Wedding Bouquet",
    code: "TBS-WB-002",
    image: "/Assets/handicrafts/image2.jpeg",
    category: "Bridal & Wedding",
  },
  {
    id: "TBS-TTA-006",
    name: "Table Top Arrangement",
    code: "TBS-TTA-006",
    image: "/Assets/handicrafts/image6.jpeg",
    category: "Home & Table Decor",
  },
  {
    id: "TBS-ALR-008",
    name: "Natural Areca Leaf Rose",
    code: "TBS-ALR-008",
    image: "/Assets/handicrafts/image8.jpeg",
    category: "Areca Leaf Crafts",
  },
  {
    id: "TBS-PPB-010",
    name: "Pistachio Petal Blossom",
    code: "TBS-PPB-010",
    image: "/Assets/handicrafts/image10.jpeg",
    category: "Shell & Nut Crafts",
  },
  {
    id: "TBS-PCP-012",
    name: "Paddy Coated Pot",
    code: "TBS-PCP-012",
    image: "/Assets/handicrafts/image12.jpeg",
    category: "Paddy & Grain Crafts",
  },
];

// Placeholder testimonial slots — replace with real client quotes
// before publishing; these are not real customer reviews.
export const testimonials = {
  eyebrow: "Client Words",
  heading: "What Our Customers Say",
  sub: "Add your own customers' words here — these are placeholder slots.",
  seeAllLabel: "See All Client Words",
  items: [
    {
      quote:
        "The craftsmanship is exceptional. Every piece we received had beautiful finishing and felt thoughtfully made. The quality was consistent even across our larger order.",
      name: "Olivia Bennett",
      location: "London, UK",
      rating: 5,
    },
    {
      quote:
        "We were impressed by how smoothly the entire sampling process went. The team understood our requirements quickly and made the custom changes exactly as requested.",
      name: "Daniel Cooper",
      location: "Melbourne, Australia",
      rating: 4,
    },
    {
      quote:
        "The natural materials and handmade detailing fit perfectly with our home decor collection. Our customers especially loved the unique character of each piece.",
      name: "Sophia Mitchell",
      location: "Toronto, Canada",
      rating: 5,
    },
    {
      quote:
        "Communication was clear throughout the order, from product selection to packaging and shipment. It made working with an overseas supplier much easier.",
      name: "James Wilson",
      location: "New York, USA",
      rating: 4,
    },
    {
      quote:
        "We were looking for something different from mass-produced decor, and the Terra Bloom collection gave us exactly that handcrafted feel we wanted.",
      name: "Amelia Carter",
      location: "Dubai, UAE",
      rating: 5,
    },
    {
      quote:
        "The product development team was very responsive to our ideas and helped us turn a simple concept into a beautiful finished collection.",
      name: "Ethan Williams",
      location: "Auckland, New Zealand",
      rating: 4,
    },
    {
      quote:
        "The attention to detail in the wood and natural-finish pieces really stood out. The products arrived well packed and matched the approved samples.",
      name: "Charlotte Morgan",
      location: "Manchester, UK",
      rating: 5,
    },
    {
      quote:
        "We appreciate the balance between traditional craftsmanship and contemporary design. The collection has become one of the strongest additions to our range.",
      name: "Noah Anderson",
      location: "Los Angeles, USA",
      rating: 4,
    },
    {
      quote:
        "From the first conversation to the final delivery, the team was professional and easy to work with. We are looking forward to developing more products together.",
      name: "Isabella Martin",
      location: "Paris, France",
      rating: 5,
    },
    {
      quote:
        "The ability to customize sizes, finishes and designs made a big difference for our collection. The final products had the premium look we were aiming for.",
      name: "Alexander Brown",
      location: "Singapore",
      rating: 4,
    },
  ],
};

export const founderSpotlight = {
  eyebrow: "About Us & Founders",
  heading: "Our Story",
};

// Real founders — quotes below are placeholders. Replace with the
// founders' own words before publishing.
export const founders = [
  {
    id: "pradeep",
    name: "Pradeep P.V.",
    title: "Founder & CEO",
    phone: "+91 95007 43890",
    initials: "PP",
    eyebrow: "Meet The Founder",
    heading: "Rooted In Kerala's Soil",
    quote:
      "I grew up watching farmers burn what they couldn't sell — corn husk, paddy straw, coconut shells left over after harvest. Terra Palm started with a simple question: what if that waste became something worth keeping forever? Every stem we shape is proof that nature's leftovers can outlive a single season.",
  },
  {
    id: "sahina",
    name: "Sahina Basheer",
    title: "Co-Founder & Creative Director",
    phone: "+91 99959 69841",
    initials: "SB",
    eyebrow: "Meet The Co-Founder",
    heading: "Where Craft Meets Colour",
    quote:
      "My work lives in the details — the curve of a sola petal, the way dried paddy catches the light. I design every arrangement to feel handmade because it is: each piece passes through an artisan's hands long before it reaches yours. That trust is what we build with every self-help group we work with.",
  },
];

export const brandStory = {
  eyebrow: brand.since,
  heading: "Brand Story",
  body: whoWeAre.paragraphs[0],
};

// "Trusted By Brands Across The Globe" reference, adapted into
// "Where We Reach" — only markets Terra Palm has actually named.
export const exportMarkets = {
  eyebrow: "Where We Reach",
  heading: "From Kerala to the World",
  regions: [
    {
      flag: Kerala,
      name: "Kerala, India",
      description:
        "Home base — sourced directly from FPO farmers and self-help groups.",
    },
    {
      flag: Germany,
      name: "Germany",
      description:
        "Represented by our agent, Kainikkara Thomas Joseph, Asperg, Germany.",
    },
    {
      flag: EU,
      name: "European Union",
      description:
        "Custom orders, bulk packaging, and export partnerships welcome worldwide.",
    },
  ],
};

// Our commitments — Terra Palm doesn't hold formal export certifications
// yet, so this lists the initiatives it stands behind instead.
export const certifications = whoWeAre.certifications;

export const agent = {
  heading: "Our Agent & Business Promoter for Germany & EU",
  name: "Kainikkara Thomas Joseph",
  altName: "Eger Str 10, Asperg, Germany",
  phones: ["+49-173 7569397", "+49-7141 3899687"],
};

export const contact = {
  email: "Javel2018@gmail.com",
  location:
    "4/944, Suryakanti Garden, Kallingal, Kodumbu, Palakkad, Kerala State — 678551",
  exportMarketsLine: "Kerala, India · Germany & EU (via agent)",
  phones: founders.map((f) => f.phone),
  responseTime: "We respond within 24 - 48 business hours.",
};

export const navLinks = [
  { label: "Home", path: "/" },
  { label: "HandiCrafts", path: "/handicrafts" },
];

export const secondaryNavLinks = [
  { label: "Our Story", path: "/our-story" },
  { label: "Our Brand", path: "/our-brand" },
  { label: "Gallery", path: "/gallery" },
  { label: "Contact Us", path: "/contact" },
];

// ---------------------------------------------------------------------
// "Our Brand" page — Terra Bloom Studio brand identity, story & mission.
// Content sourced from the brand identity reference sheet.
// ---------------------------------------------------------------------
export const ourBrand = {
  studioName: "Terra Bloom Studio",
  eyebrow: "Brand Identity",
  identity: [
    { icon: "leaf", label: "Natural", tone: "natural" },
    { icon: "hands", label: "Handmade", tone: "handmade" },
    { icon: "recycle", label: "Sustainable", tone: "sustainable" },
    { icon: "gift", label: "Meaningful", tone: "meaningful" },
  ],
  story: {
    eyebrow: "Brand Story",
    body: whoWeAre.paragraphs[0],
    brandLabel: "Eco-Friendly Decor",
    items: [
      {
        icon: leafbrand,
        title: "100% Eco-Friendly",
        text: "Utilizes natural grains, coconut shells, and sustainable cane materials for minimal environmental footprint.",
      },
      {
        icon: hands,
        title: "Artisanal Quality",
        text: "Every craft piece is meticulously hand-assembled with high attention to detail and long-lasting durability.",
      },
      {
        icon: gift,
        title: "Custom Orders",
        text: "Tailored color schemes, arrangements, and bulk packaging option available for weddings, festivals, and gifts",
      },
    ],
  },
  mission: {
    eyebrow: "Kerala Dry Flower & Eco Craft Mission",
    visionLabel: "Our Vision",
    visionText: whoWeAre.paragraphs[2],
    missionLabel: "Our Mission",
    items: [
      {
        icon: "people",
        text: "Empower women & youth through skill development and employment",
      },
      {
        icon: "leaf",
        text: "Promote sustainable and eco-friendly products",
      },
      {
        icon: "gift",
        text: "Create premium handmade products for global markets",
      },
      {
        icon: "growth",
        text: "Support rural economy and self help groups",
      },
      {
        icon: "globe",
        text: "Make Kerala a global hub for dry flower & eco crafts",
      },
    ],
  },
  whyItMatters: {
    eyebrow: "Why It Matters",
    items: whoWeAre.whyItMatters,
    note: "Small choices. Big impact.",
  },
  thankYou: {
    heading: "Thank You",
    sub: "Nature. Purity.",
  },
};

// ---------------------------------------------------------------------
// "Contact Us" page — general enquiries, address & map.
// ---------------------------------------------------------------------
export const contactPage = {
  eyebrow: "Get In Touch",
  heading: "Contact Us",
  intro:
    "Have a question about our crafts, a bulk order, or a partnership idea? We'd love to hear from you — reach out and our team will get back to you within 24–48 business hours.",
  mapQuery: contact.location,
  mapEmbedUrl: `https://www.google.com/maps?q=${encodeURIComponent(
    contact.location,
  )}&output=embed`,
  directionsUrl: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    contact.location,
  )}`,
};

export const productCategoryOptions = [
  "Bridal & Wedding",
  "Areca Leaf Crafts",
  "Wall Hangings",
  "Paddy & Grain Crafts",
  "Shell & Nut Crafts",
  "Home & Table Decor",
];

// Big sitemap-style footer (default — Home, Our Story, HandiCrafts pages).
export const footerSitemap = {
  description:
    "Handmade, eco-friendly dry flower crafts from Kerala — from Malabar Forest to your forever.",
  columns: [
    {
      title: "Product Categories",
      links: [
        "Bridal & Wedding Bouquets",
        "Areca Leaf Crafts",
        "Wall Hangings",
        "Paddy & Grain Crafts",
        "Shell & Nut Crafts",
        "Home & Table Decor",
        "Sola & Pith Crafts",
      ],
    },
  ],
  company: [
    { label: "Home", path: "/" },
    { label: "HandiCrafts", path: "/handicrafts" },
    { label: "Gallery", path: "/gallery" },
    { label: "Our Story", path: "/our-story" },
    { label: "Our Brand", path: "/our-brand" },
    { label: "Contact Us", path: "/contact" },
    { label: "Request for Quote", path: "/request-quote" },
    // { label: "Privacy Policy", path: "/" },
    // { label: "Terms of Service", path: "/" },
  ],
  social: [
    { icon: "facebook", label: "Facebook" },
    { icon: "instagram", label: "Instagram" },
    { icon: "youtube", label: "YouTube" },
    { icon: "pinterest", label: "Pinterest" },
  ],
  craftedBy: "Terra Palm Natural Creations LLP",
};

// Simple social-icon footer — used on the Request a Quote page.
export const footerSimple = {
  followLabel: "Follow us on:",
  social: [
    { icon: "facebook", label: "Facebook" },
    { icon: "instagram", label: "Instagram" },
    { icon: "youtube", label: "YouTube" },
  ],
  links: [
    { label: "Our Story", path: "/our-story" },
    { label: "Our Brand", path: "/our-brand" },
    { label: "Gallery", path: "/gallery" },
    { label: "HandiCrafts", path: "/handicrafts" },
    { label: "Contact Us", path: "/contact" },
    // { label: "Privacy Policy", path: "/" },
    // { label: "Terms of Service", path: "/" },
  ],
  callUsLabel: "Call Us -",
};
